// extracted by mini-css-extract-plugin
export default {"container":"FreeTierGettingStarted_container__xsBZr","listItem":"FreeTierGettingStarted_listItem__KIF0B"};